import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../../components/textbox/Input";
import Utils from "../../../../../../../utils/Utils";

class ContattiConDonneInGravidanza extends Component {

    state = {
        contattiConDonneInGravidanza: {
            contatto: "",
            nomeECognomeContattoDonna: "",
            corretto: []
        }
    }


    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
    }

    componentDidMount() {
        let contattiConDonneInGravidanza = this.state.contattiConDonneInGravidanza
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.contattiConDonneInGravidanza) {
            let contattiConDonneInGravidanzaCopia = this.props.segnalazioneCopia.schedaSpeciale.contattiConDonneInGravidanza
            for (let key in contattiConDonneInGravidanza) {
                if (contattiConDonneInGravidanza.hasOwnProperty(key) === contattiConDonneInGravidanzaCopia.hasOwnProperty(key)) {
                    contattiConDonneInGravidanza[key] = contattiConDonneInGravidanzaCopia[key]
                } else {
                    contattiConDonneInGravidanza[key] = ""
                }
            }
            this.setState({contattiConDonneInGravidanza: contattiConDonneInGravidanza})
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("contattiConDonneInGravidanza", oggettoBE, corretto)

        } else {
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("contattiConDonneInGravidanza", oggettoBE, corretto)
        }
    }

    riceviValore(field, event) {
        let contattiConDonneInGravidanza = this.state.contattiConDonneInGravidanza
        contattiConDonneInGravidanza[field] = event.target.value
        if (contattiConDonneInGravidanza.contatto !== "1") {
            contattiConDonneInGravidanza.nomeECognomeContattoDonna = ""
        }
        this.setState({contattiConDonneInGravidanza: contattiConDonneInGravidanza})
        let corretto = this.controlloCorrettezza()
        let oggettoBE = this.createObjectBE()
        this.props.createOggettoBeAndcontrolloCorrettezza("contattiConDonneInGravidanza", oggettoBE, corretto)
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.contattiConDonneInGravidanza))
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    controlloCorrettezza() {
        let contattiConDonneInGravidanza = this.state.contattiConDonneInGravidanza
        contattiConDonneInGravidanza.corretto = []

        if (contattiConDonneInGravidanza.contatto === "1" && !contattiConDonneInGravidanza.nomeECognomeContattoDonna) {
            contattiConDonneInGravidanza.corretto[0] = "Campo \"Se si, indicare il cognome e nome della donna\" mancante";
        }

        return contattiConDonneInGravidanza.corretto

    }

    render() {
        const {t} = this.props

        const contattiConDonneInGravidanza = (
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-lg-8"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.periodoContagiosita")}
                        </p>
                    </div>
                    <div className={"col-lg-2"}>
                        <div className={"row"}>
                            <div className={"col-lg-5"}>
                                <RadioButton id={"contattoSi"} name={"contatto"}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true}
                                             value={"1"}
                                             checked={this.state.contattiConDonneInGravidanza.contatto === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-5"}>
                                <RadioButton id={"contattoNo"} name={"contatto"}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.contattiConDonneInGravidanza.contatto === "2"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-lg-5"}>
                        <p style={{color: "black", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.seSi")}
                            <span style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                {t("SchedaSpecialeMorbillo.nomeCognomeDonna")}</span>
                            {this.state.contattiConDonneInGravidanza.contatto === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <Input id={"nomeECognomeContattoDonna"}
    onChange={this.riceviValore}
    field={"nomeECognomeContattoDonna"}
    disabled={this.state.contattiConDonneInGravidanza.contatto !== "1" ? true : false}
    value={this.state.contattiConDonneInGravidanza.nomeECognomeContattoDonna}
    placeholder={t("SchedaSpecialeMorbillo.cognome") + " " + t("SchedaSpecialeMorbillo.nome")}

    />
                    </div>
                </div>

            </div>
        )

        return (
            <div style={{marginTop: "2rem"}}>
                <h6>{t("SchedaSpecialeMorbillo.contattiConDonne")}</h6>
                <hr className={styles.hr}/>
                {contattiConDonneInGravidanza}
            </div>
        );
    }
}

export default withTranslation('common')(ContattiConDonneInGravidanza)
